import PropTypes from 'prop-types';
import { memo } from 'react';

const WorkdayTasksListItem = ({
  taskName,
  taskCompleted,
  taskLabel,
  handleChangeTask,
  disabled,
}) => {
  return (
    <div>
      <input
        type="checkbox"
        id={taskName}
        name={taskName}
        checked={taskCompleted}
        disabled={disabled}
        onChange={handleChangeTask}
        className="inline-flex w-4 h-4 text-aptiveblue-600 border-gray-300 rounded focus:ring-aptivegreen"
      />
      <label
        htmlFor={taskName}
        className={`inline-flex ml-2 text-sm ${
          disabled ? 'text-gray-400' : 'text-gray-900'
        }`}
      >
        {taskLabel}
      </label>
    </div>
  );
};

WorkdayTasksListItem.propTypes = {
  taskName: PropTypes.string.isRequired,
  taskCompleted: PropTypes.any.isRequired,
  taskLabel: PropTypes.string.isRequired,
  handleChangeTask: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default memo(WorkdayTasksListItem);
